<template>
  <el-col :span="8" class="statistic-graph">
    <el-card class="data" v-loading="loading_budget_spent">
      <div class="card-header" slot="header">
        <div class="card-header__title">
          <img class="report-img" src="@/assets/images/budget-spent-icon.svg" alt="" width="32"/>
          <span>BUDGET SPENT</span>
        </div>
        <div class="card-header__total">
          <div>Total: {{ total }}</div>
          <div class="mt5">Average: {{ avgViews }}</div>
        </div>
      </div>
      <GChart
        type="ColumnChart"
        :data="budget_spent_chart"
        :options="BarChartSett"
        v-if="budget_spent_chart.length > 1"
      />
      <div v-else class="no-data"><span>No Data</span></div>
      <div class="card-footer">
        <div class="border"></div>
      </div>
    </el-card>
  </el-col>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { GChart } from 'vue-google-charts'
import moment from "moment";
export default {
  components: {
    GChart
  },

  computed: {
    ...mapState('adminDashboard', ['BarChartSett', 'loading_budget_spent', 'budget_spent', 'date']),
    ...mapGetters('adminDashboard', ['budget_spent_chart']),

    total() {
      return this.totalBudgetSpent()
    },

    avgViews() {
      let avg = 0
      if (this.budget_spent.length > 0) {

        if (/^W[1-5]$/.test(this.budget_spent[0].period)) {
          avg = this.totalBudgetSpent(false) / moment(this.date.date_start).daysInMonth()
        }
        else avg = this.totalBudgetSpent(false) / 7
      }
      return this.commaNum(avg, 2)
    }
  },

  methods: {
    ...mapActions('adminDashboard', ['readBudgetSpent']),

    totalBudgetSpent(format = true) {
      let total = 0
      this.budget_spent.forEach(item => {
        total+= item.balance
      })
      return format ? this.commaNum(total, 2) : total
    }
  }
}
</script>
